export const textosAsistenteDeCarga = {
  titulo: 'Asistente de carga',
  etiquetaPlanilla: 'Elige la planilla de actividades (.xlsx)',
  cargar: 'Cargar actividades',
  cargando: 'Cargando…',
  etiquetaCargadas: 'Cargadas (quedan por visar)',
  etiquetaRechazadas: 'Rechazadas (revisa sus datos y vuelve a intentarlo)',
  error: 'No se pudo cargar la planilla. Intenta de nuevo.',
};
